/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { CategoryIds } from "../../models/enumerations/category-ids";
import AssessmentTitle from "../assessment-title/assessment-title";
import BaseCardLayout from "../base-card-layout/base-card-layout";
import ProgressBar from "../progress-bar/progress-bar";
import Plans from "./plans";
import CreateAccount from "./create-account";
import StripePay from "./stripe-stuff";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import { useAuthState } from '../../utilities/contexts/auth-state-context';
import CreateOrganization from "./create-organization";
import OrganizationSubscriptionService from "../../utilities/services/organization-subscription-service";
import { useHistory } from "react-router-dom";
import OrganizationService from "../../utilities/services/organization-service";
import { PlanType } from "../../models/enumerations/plan-type";
import { OrganizationSubscription } from "../../models/interfaces/organization-subscription";
import { OrganizationType, OrganizationTypeLabel } from "../../models/enumerations/organization-type";
import { PaymentCycle } from "../../models/enumerations/payment-cycle";
import AccountCreated from "./account-created";
import FunctionService from "../../utilities/services/function-service";
import UserService from "../../utilities/services/user-service";
import { createUserWithEmailAndPassword, deleteUser } from "firebase/auth";
import { User } from '../../models/interfaces/user';
import { Organization } from "../../models/interfaces/organization";
import { UserStatus } from "../../models/enumerations/user-status";
import { UserCredential } from "firebase/auth";
import getFirebase from '../../utilities/firebase';
import { UserLimit } from "../../models/enumerations/user-limit";
import { LicenseLimit } from "../../models/enumerations/license-limit";
import { OrganizationStatus } from "../../models/enumerations/organization-status";
import { useParams } from 'react-router-dom';
import UserRoles from "../../models/user-roles";
import { useTranslation } from "react-i18next";
import { PlanTypeLabels } from "../../models/plan-type";
import { LanguageSelectorUserMenu } from "../language-selector-user-menu/language-selector-user-menu";
import { query, collection, where, getDocs, getFirestore, DocumentData } from 'firebase/firestore';
import { PlanId } from "../../models/enumerations/plan-id";
import { AppContentType } from "../../models/enumerations/app-content-type";
import { createLogger } from "../../utilities/logger";
import { AppContent } from "../../models/interfaces/app-content";
import LeadLinksService from "../../utilities/services/lead-links-service";
import BaseCardLayoutActions from "../base-card-layout/base-card-layout-actions";
// import FmsClients from "../fms-clients/fms-clients";
import ScheduleMeeting from "../schedule-meeting/schedule-meeting";
import { Utils } from "../../utilities/utils";
import { TrialLengthItems } from "../organization-management/trial-length-items";
import BillingService from "../../utilities/services/billing-service";

const log = createLogger("Subscription");

const COMPONENT_CLASS = "c-subscriptions";
const LEAD_CAPTURE_LINK_TYPE = "leadCapture";
const NPE_FLOW_TYPE = "npe";
const NPE_FLOW_LEAD_TYPE = "npeLead";

interface LinkPaymentParams {
  id: string;
  userId: string;
  type?: string;
}
interface NPEPaymentPageParams {
  npeType: string;
}
const Subscription: React.FC = () => {
  window.scrollTo(0, 0);

  const { t, i18n } = useTranslation();
  const [currentProgress, setCurrentProgress] = useState<number>(1);
  const [slideTitle, setSlideTitle] = useState<string>(t('pricing.slides.plan'));
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY as string);
  const [productInfo, setProductInfo] = useState<any>();
  const [userInfo, setUserInfo] = useState<any>();
  const [organizationInfo, setOrganizationInfo] = useState<any>();
  const history = useHistory();
  const [password, setPassword] = useState<string>();
  const [termsAndConditions, setTermsAndConditions] = useState<boolean>();
  const { auth } = getFirebase();
  let authUser: UserCredential;

  const { id, type, userId } = useParams<LinkPaymentParams>();
  const isLeadCaptureLink = type === LEAD_CAPTURE_LINK_TYPE && !!userId;
  const { npeType } = useParams<NPEPaymentPageParams>();
  const isNPELink = npeType === NPE_FLOW_LEAD_TYPE;
  const params = new URLSearchParams(window.location.search);
  const couponId = params.get("couponId");

  const { state, setState } = useAuthState();

  if (npeType === NPE_FLOW_TYPE && state.user?.leadLinkId && state.user?.id) {
    couponId
      ? history.replace(`/lc-pricing/${state.user.leadLinkId}/${LEAD_CAPTURE_LINK_TYPE}/${state.user.id}/npeLead?couponId=${couponId}`)
      : history.replace(`/lc-pricing/${state.user.leadLinkId}/${LEAD_CAPTURE_LINK_TYPE}/${state.user.id}/npeLead`);
  }
  else if (npeType === NPE_FLOW_TYPE && !state.authenticated) {
    couponId
      ? history.replace(`/login?isNpe=true&couponId=${couponId}`)
      : history.replace(`/login`);
  }

  // Clear state.temp on first load
  useEffect(() => {
    if (state.temp) {
      setState((state) => ({
        ...state,
        ...{ temp: null }
      }));

      setCurrentProgress(1);
      setUserInfo(undefined);
      setProductInfo(undefined);
      setOrganizationInfo(undefined);
    }
  }, []);

  useEffect(() => {
    const getLeadCaptureUser = async () => {
      let leadUser: User | null = null;

      try {
        leadUser = await UserService.get(userId);
      } catch (err) {
        log.error("Cannot fetch the user ID", {
          exception: err,
          userId,
        });
      } finally {
        setUserInfo(leadUser);
      }
    }

    if (isLeadCaptureLink && id && userId) {
      getLeadCaptureUser();
    }
  }, [id, isLeadCaptureLink])

  useEffect(() => {
    if (isNPELink && couponId) {
      if (state.authenticated && state.user?.id && state.organization && state.user.id === state.organization?.accountHolderId && state.organization.plan?.value === PlanType.Trial) {
        history.replace(`/settings/upgrade?couponId=${couponId}`);
      }
      else if (state.authenticated && state.user?.id && state.organization && state.user.id === state.organization?.accountHolderId) {
        history.replace("/");
      }
      else if (state.authenticated) {
        grabPaidPlan();
      }
      else {
        history.replace(`/login?isNpe=true&couponId=${couponId}`);
      }
    } else if (isNPELink && !couponId) {
      setUserInfo(state.user);
    }
  }, [isNPELink]);


  const changeProgress = (progressNumber: number, slideTitle: string) => {
    setCurrentProgress(progressNumber);
    setSlideTitle(slideTitle);
  }

  useEffect(() => {
    setState((state) => ({
      ...state, ...{ temp: { product: productInfo, progress: currentProgress, user: userInfo, organization: organizationInfo } }
    }));
  }, [currentProgress, productInfo, userInfo, organizationInfo, setState]);

  const grabPaidPlan = async () => {
    const db = getFirestore();
    const q = query(
      collection(db, 'products'),
      where('active', '==', true),
    );
    const querySnapshot = await getDocs(q);
    const productsPromises = querySnapshot.docs.map(async (productDoc, index) => {
      if (productDoc.id === PlanId.Pro) {
        let product = productDoc.data();
        const pricesCollection = collection(productDoc.ref, 'prices');
        const priceQuerySnapshot = await getDocs(pricesCollection);

        const priceInfo: DocumentData[] = [];
        // eslint-disable-next-line array-callback-return
        priceQuerySnapshot.docs.map((priceDoc, index) => {
          priceInfo[index] = priceDoc.data();
          priceInfo[index]['id'] = priceDoc.id;
        });
        product['priceInfo'] = priceInfo;

        return product;
      }
    });
    await Promise.all(productsPromises).then((result) => {
      const product = result.filter(productDoc => productDoc && productDoc.id === PlanId.Pro)
      handleSelectedProduct({ ...product[0], interval: PaymentCycle.Monthly });
    });
  }

  const handleSelectedProduct = async (data: any) => {
    if (data.name || data === 'STARTER') {
      setProductInfo(data);

      if (!isNPELink) {
        if (state?.temp?.user && state?.temp?.organization && data === 'STARTER')
          handleOrganizationCreate(state.temp.organization, data);
        else if (state?.temp?.user && state?.temp?.organization && data !== 'STARTER') {
          if (isLeadCaptureLink) {
            changeProgress(3, t('pricing.slides.payment'));
          } else {
            changeProgress(4, t('pricing.slides.payment'));
          }
        }
        else if (state?.temp?.user && !state?.temp?.organization) {
          if (isLeadCaptureLink) {
            changeProgress(2, t('pricing.slides.org'));
          } else {
            changeProgress(3, t('pricing.slides.org'));
          }
        }
        else {
          if (!isLeadCaptureLink)
            changeProgress(2, t('pricing.slides.account'));
        }
      } else {
        if (state.user && state.user.id)
          if (data === 'STARTER') {
            let leadLink = id ? await LeadLinksService.get(id) : null;

            const npeOrganization = {
              appContent: {
                [AppContentType.PAIN]: {} as AppContent,
                [AppContentType.BEHAVIORAL_HEALTH]: {} as AppContent,
              },
              status: OrganizationStatus.Active,
              name: state.user.npeTemp!.orgName,
              industry: Utils.getIndustryObject(state.user.npeTemp!.orgIndustry),
              leadLinkId: id ? id : '',
              orgDefaultContentConfig: leadLink ? leadLink.orgDefaultContentConfig : undefined,
            };
            handleOrganizationCreate(npeOrganization, data);
          }
          else
            changeProgress(3, t('pricing.slides.payment'));
      }
    }
  }

  const handleAccountCreate = (data: any, password: string, termsAndConditions: boolean) => {
    if (data) {
      setUserInfo(data);
      setPassword(password);
      setTermsAndConditions(termsAndConditions);
      changeProgress(3, t('pricing.slides.org'));
    } else {
    }
  }

  const handleOrganizationCreate = async (data: any, product: any) => {
    if (data) {
      if (product === 'STARTER') { // this may be obsolete, not sure why it wasnt removed. we dont have starters anymore
        const result = finalizeCreate(state.temp.user, data);
        if (await result === 'SUCCESS') {
          try {
            await BillingService.trialSignupCustomer({
              email: state.temp.user.email!,
              firstName: state.temp.user.firstName!,
              lastName: state.temp.user.lastName!,
              preferredLocale: i18n.language,
            });
            log.info("Trial Stripe customer created during checkout");
          } catch (e) {
            log.error("Failed to create trial Stripe customer during checkout", {
              exception: e,
              email: state.temp.user.email,
            });
          }

          try {
            FunctionService.sendTrialWelcomeEmail(state.temp.user);
          }
          catch (err) {
            log.error("Failed to send trial welcome email", {
              exception: err,
            });
          }

          if (isLeadCaptureLink)
            changeProgress(4, t('pricing.slides.confirmation'));
          else
            changeProgress(5, t('pricing.slides.confirmation'));
        } else {
        };

      } else {
        if (isLeadCaptureLink)
          changeProgress(3, t('pricing.slides.payment'));
        else
          changeProgress(4, t('pricing.slides.payment'));
        setOrganizationInfo(data);
      }
    } else {
    }
  }

  const handlePaymentSuccessful = () => {
    log.info("Checkout completed", {
      planType: productInfo?.planType,
    });
    setState((state) => ({
      ...state, ...{ temp: { progress: 1, user: null, organization: null, product: null } }
    }));
    setOrganizationInfo(null);
    setProductInfo(null);
    setUserInfo(null);
    history.push("/dashboard");
  };

  const cleanUpState = (user: User, organization: Organization) => {
    setState((state) => ({
      ...state, ...{
        temp: {
          product: productInfo,
          progress: currentProgress,
          user: { ...user },
          organization: { ...organization }
        }
      }
    }));
  }

  const handlePlansBackButton = () => {
    if (isLeadCaptureLink) {
      history.push('/lc-assessment-results');
    }
    else {
      window.location.href = 'https://www.symmio.com/pricing';
    }
  }

  async function finalizeCreate(user: User, organization: Organization): Promise<string> {
    if (!isLeadCaptureLink && !state.user) {
      try { authUser = await createUserWithEmailAndPassword(auth, user.email!.toLowerCase(), password!); }
      catch (error: any) {
        log.error("Checkout failed: auth signup failed", {
          exception: error,
          email: user.email?.toLowerCase(),
          code: error.code,
        });
        switch (error.code) {
          case "auth/user-not-found":
            cleanUpState(user, organization);
            return t('forms.err_emailDoesNotExist');
          case "auth/email-already-in-use":
            cleanUpState(user, organization);
            return t('forms.err_emailInUse');
          case "auth/invalid-email":
            cleanUpState(user, organization);
            return t('forms.err_emailInvalid');
          case "auth/weak-password":
            cleanUpState(user, organization);
            return t('forms.err_password8');
          default:
            return error.code;
        }
      }
      if (authUser?.user == null) {
        log.warn("Checkout failed: no auth user returned", {
          email: user.email?.toLowerCase(),
        });
        cleanUpState(user, organization);
        return t('forms.err_userNotFound', { email: user.email!.toLowerCase() });
      }

      if (authUser?.user == null) {
        cleanUpState(user, organization);
        return t('forms.err_userNotFound', { email: user.email!.toLowerCase() });
      }

      // Constructing the user for creation.
      const userCreate: User = {
        ...user,
        roles: [UserRoles.ACCOUNT_HOLDER_ID],
        preferredLanguage: i18n.language,
        notificationSettings: {
          inactiveUser: true,
          highRiskUser: true,
          dayStreakMilestone: true,
          newAccount: true,
          completedTasks: true,
          baselineAssessment: true,
        },
        emailNotificationSettings: {
          baselineAssessment: false,
          highRiskUser: false,
          startedProgram: false,
          completedProgram: false,
        },
        authenticationId: authUser.user.uid,
      };

      // Creating the user.
      await UserService.save(userCreate).then(async (createdUser) => {
        if (createdUser && createdUser.id) {
          log.info("Account created during checkout", {
            userId: createdUser.id,
          });
          // Constructing the organization for creation.
          const organizationCreate: Organization = {
            ...organization,
            accountHolderId: createdUser.id,
            userLimit: UserLimit.Trial,
            userCount: 1,
            organizationLimit: 1,
            mySymmioLicense: LicenseLimit.Trial,
            plan: { value: PlanType.Trial, label: PlanTypeLabels[PlanType.Trial] },
            status: OrganizationStatus.Active,
          };

          // Creating the organization.
          await OrganizationService.add(organizationCreate).then(async (createdOrg) => {
            if (createdOrg && createdOrg.id) {
              log.info("Organization created during checkout", {
                organizationId: createdOrg.id,
              });
              // Construct the user for updating. (Add organizationId)
              const updateUser: User = {
                ...createdUser,
                organizationId: createdOrg.id,
                status: UserStatus.Active,
                isSuperAdmin: false,
              }

              await UserService.save(updateUser).catch((updUserError) => {
                log.error("Failed to save user during checkout", {
                  exception: updUserError,
                  userId: createdUser.id,
                  organizationId: createdOrg.id,
                });
                UserService.deleteById(createdUser.id!);
                OrganizationService.deleteById(createdOrg.id!);
                if (auth.currentUser && auth.currentUser.uid === createdUser.authenticationId)
                  deleteUser(auth.currentUser);
                cleanUpState(user, organization);
                return t('pricing.general.err_orgSub');
              });

              let orgSub: OrganizationSubscription;

              const startDate = new Date();
              const renewDate = new Date(startDate);
              renewDate.setMonth(startDate.getMonth() + 1);

              orgSub = {
                organizationId: createdOrg.id,
                accountType: {
                  label: OrganizationTypeLabel[OrganizationType.Trial],
                  value: OrganizationType.Trial,
                },
                organizationLimit: 1,
                startDate: startDate.toISOString(),
                renewDate: renewDate.toISOString(),
                userLimit: UserLimit.Trial,
                price: 0,
                plan: {
                  value: PlanType.Trial,
                  label: PlanTypeLabels[PlanType.Trial],
                },
                paymentCycle: {
                  label: PaymentCycle[PaymentCycle.Monthly],
                  value: PaymentCycle.Monthly,
                },
                trialLength: TrialLengthItems.find((x) => x.value === 30),
                mySymmioLicense: UserLimit.Trial
              };
              await OrganizationSubscriptionService.save(orgSub).catch((orgSubError) => {
                log.error("Failed to save organization subscription during checkout", {
                  exception: orgSubError,
                  organizationId: createdOrg.id,
                  userId: createdUser.id,
                });
                UserService.deleteById(createdUser.id!);
                OrganizationService.deleteById(createdOrg.id!);
                if (auth.currentUser && auth.currentUser.uid === createdUser.authenticationId)
                  deleteUser(auth.currentUser);
                cleanUpState(user, organization);
                return t('pricing.general.err_orgSub');
              });
              log.info("Trial organization subscription saved during checkout", {
                organizationId: createdOrg.id,
                trialLength: 30,
              });

              // Set the state to prepare everything for logging in.
              setState((state) => ({
                ...state, ...{
                  user: {
                    ...updateUser,
                    organizationId: createdOrg.id,
                  },
                  organization: {
                    ...createdOrg,
                  },
                  temp: {
                    progress: currentProgress,
                    product: productInfo,
                    user: { ...updateUser },
                    organization: { ...createdOrg },
                  }
                }
              }));
            }
          }).catch((orgError) => {
            log.error("Failed to create organization during checkout (new user path)", {
              exception: orgError,
              userId: createdUser.id,
            });
            // TODO: Delete user and authUser
            UserService.deleteById(createdUser.id!);
            if (auth.currentUser && auth.currentUser.uid === createdUser.authenticationId)
              deleteUser(auth.currentUser);
            cleanUpState(user, organization);
            return t('pricing.general.err_org');
          });

        }
      }).catch((userError) => {
        log.error("Failed to create user during checkout", {
          exception: userError,
          email: user.email,
        });
        // TODO: Delete authUser
        if (auth.currentUser)
          deleteUser(auth.currentUser);
        cleanUpState(user, organization);
        return t('pricing.general.err_org');
      });
      return "SUCCESS";
    } else {
      // Constructing the organization for creation.
      const organizationCreate: Organization = {
        ...organization,
        accountHolderId: user && user.id ? user.id : state.user?.id,
        userLimit: UserLimit.Trial,
        userCount: 1,
        organizationLimit: 1,
        mySymmioLicense: LicenseLimit.Trial,
        plan: { value: PlanType.Trial, label: PlanTypeLabels[PlanType.Trial] },
        status: OrganizationStatus.Active,
      };

      // Creating the organization.
      await OrganizationService.add(organizationCreate).then(async (createdOrg) => {
        if (createdOrg && createdOrg.id) {
          log.info("Organization created during checkout", {
            organizationId: createdOrg.id,
          });
          // Construct the user for updating. (Add organizationId)
          const updateUser: User = {
            ...user,
            organizationId: createdOrg.id,
            roles: [UserRoles.ACCOUNT_HOLDER_ID],
            status: UserStatus.Active,
            isSuperAdmin: false,
            groupId: null,
            groupName: null,
            tagIds: [],
            tags: [],
            npeTemp: null,
          }

          await UserService.save(updateUser).catch((updUserError) => {
            log.error("Failed to save user during checkout", {
              exception: updUserError,
              userId: user.id,
              organizationId: createdOrg.id,
            });
            UserService.deleteById(user.id!);
            OrganizationService.deleteById(createdOrg.id!);
            if (auth.currentUser && auth.currentUser.uid === user.authenticationId)
              deleteUser(auth.currentUser);
            cleanUpState(user, organization);
            return t('pricing.general.err_orgSub');
          });

          let orgSub: OrganizationSubscription;

          const startDate = new Date();
          const renewDate = new Date(startDate);
          renewDate.setMonth(startDate.getMonth() + 1);

          orgSub = {
            organizationId: createdOrg.id,
            accountType: {
              label: OrganizationTypeLabel[OrganizationType.Trial],
              value: OrganizationType.Trial,
            },
            organizationLimit: 1,
            startDate: startDate.toISOString(),
            renewDate: renewDate.toISOString(),
            userLimit: UserLimit.Trial,
            price: 0,
            plan: {
              value: PlanType.Trial,
              label: PlanTypeLabels[PlanType.Trial],
            },
            paymentCycle: {
              label: PaymentCycle[PaymentCycle.Monthly],
              value: PaymentCycle.Monthly,
            },
            trialLength: TrialLengthItems.find((x) => x.value === 30),
            mySymmioLicense: UserLimit.Trial
          };
          await OrganizationSubscriptionService.save(orgSub).catch((orgSubError) => {
            log.error("Failed to save organization subscription during checkout", {
              exception: orgSubError,
              organizationId: createdOrg.id,
              userId: user.id,
            });
            UserService.deleteById(user.id!);
            OrganizationService.deleteById(createdOrg.id!);
            if (auth.currentUser && auth.currentUser.uid === user.authenticationId)
              deleteUser(auth.currentUser);
            cleanUpState(user, organization);
            return t('pricing.general.err_orgSub');
          });
          log.info("Trial organization subscription saved during checkout", {
            organizationId: createdOrg.id,
            trialLength: 30,
          });

          // Set the state to prepare everything for logging in.
          setState((state) => ({
            ...state, ...{
              user: {
                ...updateUser,
                organizationId: createdOrg.id,
              },
              organization: {
                ...createdOrg,
              },
              temp: {
                progress: currentProgress,
                product: productInfo,
                user: { ...updateUser },
                organization: { ...createdOrg },
              }
            }
          }));
        }
      }).catch((orgError) => {
        log.error("Failed to create organization during checkout", {
          exception: orgError,
        });
        // TODO: Delete user and authUser
        UserService.deleteById(user.id!);
        if (auth.currentUser && auth.currentUser.uid === user.authenticationId)
          deleteUser(auth.currentUser);
        cleanUpState(user, organization);
        return t('pricing.general.err_org');
      });
      return "SUCCESS";
    }

  }


  return (
    <>
      <div className="user-menu">
        <LanguageSelectorUserMenu userPortal={false} />
      </div>
      <BaseCardLayout>
        <div className={`${COMPONENT_CLASS}`}>
          <div className={`${COMPONENT_CLASS}__wrapper`}>
            <div className={`${COMPONENT_CLASS}__content`}>
              {((isLeadCaptureLink && currentProgress !== 4) || (!isLeadCaptureLink && currentProgress !== 5)) && (
                <>
                  <ProgressBar
                    currentProgress={currentProgress}
                    total={isLeadCaptureLink ? 4 : 5}
                    category={CategoryIds.MOVEMENT}
                    headerText={t('pricing.tabs.createAccount')} />
                  <AssessmentTitle
                    title={slideTitle}
                  />
                </>
              )}

              {currentProgress === 1 && (
                <div>
                  <div className="md:px-16 px-8 pt-10">
                    <div className="text-center">
                      <h1 className="text-center mb-10">
                        {t('pricing.plansPage.title')}
                      </h1>
                      <p>
                        {t('pricing.plansPage.description')}
                      </p>
                    </div>
                    {/* add negative margin to this to make grey background span the entire parent div */}
                    {/* <div className="w-full py-4 flex flex-col items-center text-center" style={{ background: "#FAFAFA" }}>
                      <FmsClients />
                    </div> */}
                    <Plans
                      onProductSelect={handleSelectedProduct}
                      isUpgrade={false}
                      isLeadCapture={isLeadCaptureLink}
                    />

                    <div className="flex flex-wrap">
                      <ScheduleMeeting />
                    </div>
                  </div>
                  <BaseCardLayoutActions
                    backButton={true}
                    onBack={handlePlansBackButton}
                  />
                </div>
              )}
              {isLeadCaptureLink && currentProgress === 2 && (
                <CreateOrganization
                  onBackClick={() => { setProductInfo(null); changeProgress(1, t('pricing.slides.plan')); }}
                  onSubmitClick={() => { }}
                  onOrganizationCreate={handleOrganizationCreate}
                />)}
              {isLeadCaptureLink && (currentProgress === 3 && state.temp.product && state.temp.product !== "STARTER") && (
                <Elements stripe={stripePromise}>
                  <StripePay
                    onInfoCreate={finalizeCreate}
                    onBackClick={() =>
                      isNPELink ? history.push("/lc-assessment-results") : changeProgress(3, t('pricing.slides.org'))}
                    onSubmitClick={() => {
                      FunctionService.sendAccountOwnerWelcomeEmail(state.temp.user);
                      changeProgress(4, t('pricing.slides.confirmation'));
                    }}
                    onChange={() => {
                      setProductInfo(null);
                      changeProgress(1, t('pricing.slides.plan'));
                    }}
                  />
                </Elements>
              )}
              {isLeadCaptureLink && currentProgress === 4 && (
                <AccountCreated
                  welcomeText={productInfo === "STARTER" ? t('pricing.accountCreatedPage.subStarter') : t('pricing.accountCreatedPage.subBusiness')}
                  onSubmitClick={handlePaymentSuccessful}
                />
              )}
              {!isLeadCaptureLink && currentProgress === 2 && (
                <CreateAccount
                  onBackClick={() => { setProductInfo(null); changeProgress(1, t('pricing.slides.plan')); }}
                  onAccountCreate={handleAccountCreate}
                  additionalInfo={{ password: password, termsAndConditions: termsAndConditions }}
                />)}
              {!isLeadCaptureLink && currentProgress === 3 && (
                <CreateOrganization
                  onBackClick={() => { changeProgress(2, t('pricing.slides.account')); }}
                  onSubmitClick={() => { }}
                  onOrganizationCreate={handleOrganizationCreate}
                />)}
              {!isLeadCaptureLink && (currentProgress === 4 && state.temp.product && state.temp.product !== "STARTER") && (
                <Elements stripe={stripePromise}>
                  <StripePay
                    onInfoCreate={finalizeCreate}
                    onBackClick={() => {
                      changeProgress(3, t('pricing.slides.org'));
                    }}
                    onSubmitClick={() => {
                      FunctionService.sendAccountOwnerWelcomeEmail(state.temp.user);
                      changeProgress(5, t('pricing.slides.confirmation'));
                    }}
                    onChange={() => {
                      setProductInfo(null);
                      changeProgress(1, t('pricing.slides.plan'));
                    }}
                  />
                </Elements>
              )}
              {!isLeadCaptureLink && currentProgress === 5 && (
                <AccountCreated
                  welcomeText={productInfo === "STARTER" ? t('pricing.accountCreatedPage.subStarter') : t('pricing.accountCreatedPage.subBusiness')}
                  onSubmitClick={handlePaymentSuccessful}
                />
              )}
            </div>
          </div>
        </div>
      </BaseCardLayout>
    </>
  );
}

export default Subscription;